import styles from "./ModalCriarRota.module.css";
import { Field, Form, Formik } from "formik";
import Button from "../../../../components/components-ui/Button/Button";
import { Col, Grid } from "../../../../components/Grid";
import { SelectSearch } from "../../../../components/components-ui/SelectSearch/SelectSearch";
import api from "../../../../services/Api";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";
import CustomConfirmAlert from "../../../../components/components-ui/CustomConfirmAlert/CustomConfirmAlert";
import Loading from "../../../../components/components-ui/Loading/Loading";

const API_VEICULOS = "/veiculo/index";
const API_MOTORISTAS = "/motorista/listamotorista";
const API_CRIA_FREGUESIA = "/freguesia/criafreguesia";

const today = new Date();
today.setDate(today.getDate() + 1);
const DATA_AMANHA = today.toISOString().split("T")[0];

function CriarRota({ tipoFreguesia, freguesia, tempName, back, closeModal }) {
  const [motoristas, setMotoristas] = useState([]);
  const [veiculos, setVeiculos] = useState([]);

  const getMostoristas = async () => {
    await api
      .get(API_MOTORISTAS)
      .then((res) => setMotoristas(res.data.data))
      .catch((error) => console.log(error));
  };

  const getVeiculos = async () => {
    await api
      .get(API_VEICULOS)
      .then((res) => setVeiculos(res.data))
      .catch((error) => console.log(error));
  };

  //Carregar selects motoristas e veiculos
  useEffect(() => {
    getMostoristas();
    getVeiculos();
  }, []);

  const criarFreguesia = async (values) => {
    const data = {
      freguesia_avulsa: tipoFreguesia,
      nome_freguesia: freguesia,
      data_programacao: values?.dataSaida,
      id_motorista: values?.motorista,
      id_veiculo: values?.veiculo,
      numero_certificado_de: values?.certificadoDe,
      numero_certificado_ate: values?.certificadoAte,
      quanto_levou: values?.levou,
      temp_name: tempName ?? null,
    };

    console.log(data);

    await api
      .post(API_CRIA_FREGUESIA, data)
      .then((res) => {
        if (res.data.error === 0) {
          console.log(res);
          toast.success(res.data.msgError);
          closeModal();
          back();
        } else if (res.data.error === 2) {
          console.log(res.data);
          alertError(
            res.data.data.Freguesia,
            res.data.data.DataProgramacao,
            res.data.data.IDOC
          );
        } else {
          toast.warn(res.data.msgError);
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Erro ao criar a freguesia: " + error.message);
        Sentry.captureException(error, {
          extra: {
            response: error.response?.data.message,
            status: error.response?.status,
            url: API_CRIA_FREGUESIA,
            payload: data,
          },
        });
      });
  };

  const alertError = (freguesia, dia, idOc) => {
    CustomConfirmAlert({
      title: "Atenção!",
      subtitle: `Existe uma freguesia ${freguesia} para o dia ${dia}. OC (${idOc}) \n
      Não é possível criar essa freguesia.\n
      Não é permitido ter duas freguesias com o mesmo veiculo para o mesmo dia em andamento
      `,
      align: "start",
    });
  };

  const validationSchema = Yup.object().shape({
    dataSaida: Yup.date().required("Insira a data"),
    veiculo: Yup.string().nullable().required("Insira o veiculo"),
    motorista: Yup.string().nullable().required("Insira o motorista"),
    levou: Yup.number()
      .positive()
      .min(0, "Insira um numero positivo")
      .nullable(),
    certificadoDe: Yup.string().nullable(),
    certificadoAte: Yup.string().nullable(),
  });

  return (
    <div className={styles.modal_container}>
      <Formik
        initialValues={{
          dataSaida: DATA_AMANHA,
          veiculo: null,
          motorista: null,
          levou: null,
          certificadoDe: null,
          certificadoAte: null,
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => criarFreguesia(values)}
      >
        {({ errors, touched, values, isSubmitting, isValid }) => (
          <Form>
            {/* Modal Criar Rota */}
            <div>
              <Grid>
                <Col size={3}>
                  <label>Data de Saída</label>
                  <Field type="date" name="dataSaida" />
                  {errors.dataSaida && touched.dataSaida ? (
                    <span className={styles.alertError}>
                      {errors.dataSaida}
                    </span>
                  ) : null}
                </Col>
                <Col size={3}>
                  <label>Veículo</label>
                  <Field
                    component={SelectSearch}
                    name="veiculo"
                    options={veiculos.map((values) => ({
                      label: values?.placa,
                      value: values?.IDVeiculo,
                    }))}
                  />
                  {errors.veiculo && touched.veiculo ? (
                    <span className={styles.alertError}>{errors.veiculo}</span>
                  ) : null}
                </Col>
                <Col size={6}>
                  <label>Motorista</label>
                  <Field
                    component={SelectSearch}
                    name="motorista"
                    options={motoristas.map((values) => ({
                      label: values?.NomeUsuario,
                      value: values?.IdUsuario,
                    }))}
                  />
                  {errors.motorista && touched.motorista ? (
                    <span className={styles.alertError}>
                      {errors.motorista}
                    </span>
                  ) : null}
                </Col>
              </Grid>
              <Grid>
                <Col size={2}>
                  <label>Levou R$</label>
                  <Field type="number" name="levou" step={1} />
                  {errors.levou && touched.levou ? (
                    <span className={styles.alertError}>{errors.levou}</span>
                  ) : null}
                </Col>
                <Col size={5}>
                  <label>Nº Cert. De</label>
                  <Field type="text" name="certificadoDe" />
                  {errors.certificadoDe && touched.certificadoDe ? (
                    <span className={styles.alertError}>
                      {errors.certificadoDe}
                    </span>
                  ) : null}
                </Col>
                <Col size={5}>
                  <label>Nº Cert. Até</label>
                  <Field type="text" name="certificadoAte" />
                  {errors.certificadoAte && touched.certificadoAte ? (
                    <span className={styles.alertError}>
                      {errors.certificadoAte}
                    </span>
                  ) : null}
                </Col>
              </Grid>
              <div className={styles.buttons_container}>
                <Col size={5}>
                  <Button
                    title="Criar Rota"
                    type="submit"
                    disabled={isSubmitting}
                    className={styles.button_sm}
                  />
                </Col>
                <Col size={5}>
                  <Button
                    title="Fechar"
                    color="secondary"
                    onClick={() => closeModal()}
                    disabled={isSubmitting}
                    className={styles.button_sm}
                  />
                </Col>
              </div>
              {isSubmitting && (
                <div className={styles.loading_container}>
                  <Loading display={isSubmitting ? "block" : "none"} />
                </div>
              )}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default CriarRota;
